import { Flex, Input, InputGroup, InputLeftAddon } from '@chakra-ui/react'
import { forwardRef } from 'react'
import { useForm } from 'react-hook-form'
import { Button } from '../../../components/Button'

export function SearchForm({ onSearch, isLoading }) {
  const { handleSubmit, register } = useForm()

  function onSubmit(data) {
    onSearch(data)
  }

  return (
    <Flex alignItems="center" justifyContent="center" gap={2} as="form" onSubmit={handleSubmit(onSubmit)}>
      <InputForm {...register('busca')} children="COD / E-mail / CPF/Cnpj / Razão Social" id="cod" fontSize="15px" maxW="600px" />

      <Button maxW="114px" w="full" type="submit" isLoading={isLoading}>
        Buscar
      </Button>
    </Flex>
  )
}

const InputForm = forwardRef(({ children, ...props }, ref) => {
  return (
    <InputGroup maxW={props.maxW} w={props.w}>
      <InputLeftAddon
        color="#378BBF"
        fontWeight="semibold"
        as="label"
        fontSize={props.fontSize}
        htmlFor={props.id}
        children={children}
        borderRadius="0"
        px={2}
      />
      <Input id={props.id} borderRadius="0" ref={ref} {...props} />
    </InputGroup>
  )
})
